import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService , CanActivateAuthGuard} from 'src/config/auth.guard';
import { LoginComponent } from './components/shared/login/login.component';
import { RequestComponent } from './components/shared/request/request.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
// import { MapaScreenPrintComponent } from './components/mapa-screen-print/mapa-screen-print.component';


export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'request', component: RequestComponent },
  {
      path: 'home',
      component: DashboardComponent,
      loadChildren: './components/pages.module#PagesModule',
      canLoad: [AuthGuardService], canActivate: [ CanActivateAuthGuard]
  },
  { path: '**', pathMatch: 'full', redirectTo: '/login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
